module.exports = __webpack_public_path__ + "static/media/phone_frame.e2cc4c72.svg";